import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { setDefaultOptions } from 'date-fns';
import { nl } from 'date-fns/locale';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';

setDefaultOptions({
  locale: nl,
});

@Component({
  imports: [RouterModule, IonApp, IonRouterOutlet],
  selector: 'alfred-web-app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
